import { messageSaveAPI, messageGetAPI } from '@/servers/agent-v2'
import { safeParseJson } from '@/utils'

const jsonStringify = (value: any) => {
  try {
    return JSON.stringify(value)
  } catch (error) {
    return ''
  }
}

export const saveActionRecordToServer = async (params: {
  message_id: string
  value: Record<string, any>
  mergeRemoteData?: boolean
}) => {
  let obj = {
    ...params.value
  }

  if (params.mergeRemoteData) {
    const res = await messageGetAPI({ message_id: params.message_id })
    if (res.code === 0) {
      const remoteExtData = safeParseJson(res.data.ext_data)
      if (remoteExtData !== null && remoteExtData !== undefined && remoteExtData !== '') {
        obj = { ...remoteExtData, ...params.value }
      }
    }
  }

  await messageSaveAPI({
    message_id: params.message_id,
    value: jsonStringify(obj)
  })
}
